import * as R from "ramda";
const parseExternalReference = (artefact, type) => {
  if (R.not(R.prop("isExternalReference", artefact))) {
    return null;
  }
  const externalRef = R.pipe(
    R.propOr([], "links"),
    R.find(R.propEq("external", "rel"))
  )(artefact);
  if (R.isNil(externalRef)) {
    return null;
  }
  const href = externalRef.href;
  const [endpoint, identifiers] = R.split(`/${type}/`, href);
  if (R.any(R.isNil, [endpoint, identifiers])) {
    return null;
  }
  const [agencyId, code, version] = R.split("/", identifiers);
  if (R.any(R.isNil, [agencyId, code, version])) {
    return null;
  }
  return {
    datasource: { url: endpoint },
    identifiers: { agencyId, code, version }
  };
};
export {
  parseExternalReference
};
